import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter
} from "react-router-dom";
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'

import AmChillWhaleApp, { APP_ACW_ROUTINGS } from "./AmChillWhaleApp.jsx";

TimeAgo.addDefaultLocale(en)

export class App extends Component {

    render() {
      withRouter(AmChillWhaleApp);
      const routings = APP_ACW_ROUTINGS.map ((r, index) => <Route key={index} path={r} component={AmChillWhaleApp} /> )
      return <Router>
        <Switch>
          {routings}
        </Switch>
      </Router>;
    }
}

export default App;
